import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountLabelComponent } from '@app/shared/components/campaign-adgroup-label/account-label.component';
import { AdGroupLabelComponent } from '@app/shared/components/campaign-adgroup-label/ad-group-label.component';
import { CampaignLabelComponent } from '@app/shared/components/campaign-adgroup-label/campaign-label.component';
import { CriterionLabelComponent } from '@app/shared/components/campaign-adgroup-label/criterion-label.component';
import { PerformanceGroupLabelComponent } from '@app/shared/components/campaign-adgroup-label/performance-group-label.component';
import { ExplorerHrefDirective } from '@app/shared/directives/explorer-href.directive';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SharedDirectivesModule } from '../../shared-directives.module';
import { AdvancedFilterModule } from '../advanced-filter/advanced-filter.module';

import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';
import { AccountSelectorComponent } from './components/account-selector/account-selector.component';
import { AdGroupSelectorComponent } from './components/ad-group-selector/ad-group-selector.component';
import { BaseGlobalSelectorComponent } from './components/base-global-selector/base-global-selector.component';
import { CampaignSelectorComponent } from './components/campaign-selector/campaign-selector.component';
import { CriteriaSelectorComponent } from './components/criteria-selector/criteria-selector.component';
import { GlobalFilterSelectorListComponent } from './components/global-filter-selector-list/global-filter-selector-list.component';
import { GlobalSelectorDialogContentComponent } from './components/global-selector-dialog-content/global-selector-dialog-content.component';
import { PgSelectorComponent } from './components/pg-selector/pg-selector.component';
import { SelectorButtonComponent } from './components/selector-button/selector-button.component';

@NgModule({
  declarations: [
    GlobalSelectorDialogContentComponent,
    GlobalFilterSelectorListComponent,
    SelectorButtonComponent,
    BaseGlobalSelectorComponent,
    AccountSelectorComponent,
    PgSelectorComponent,
    CampaignSelectorComponent,
    AdGroupSelectorComponent,
    CriteriaSelectorComponent,
  ],
  exports: [
    GlobalSelectorDialogContentComponent,
    GlobalFilterSelectorListComponent,
    SelectorButtonComponent,
    BaseGlobalSelectorComponent,
    AccountSelectorComponent,
    PgSelectorComponent,
    CampaignSelectorComponent,
    AdGroupSelectorComponent,
    CriteriaSelectorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollingModule,
    TranslateModule,

    NzButtonModule,
    NzDropDownModule,
    NzInputModule,
    NzSpinModule,
    SpinnerOverlayComponent,
    NzToolTipModule,
    NzTabsModule,

    SharedDirectivesModule,

    AdvancedFilterModule,
    NzTagModule,
    AccountLabelComponent,
    PerformanceGroupLabelComponent,
    CampaignLabelComponent,
    AdGroupLabelComponent,
    CriterionLabelComponent,
    ExplorerHrefDirective,
  ],
})
export class GlobalFiltersModule {}
